/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Title_PageInputs */

const vi_shop_home_title_page = /** @type {(inputs: Shop_Home_Title_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trang chủ`)
};

/**

* @param {Shop_Home_Title_PageInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_title_page = /** @type {((inputs?: Shop_Home_Title_PageInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Title_PageInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_title_page(inputs)
});